<div class="row" *ngIf="showFileUpload">
   <div class="input-field col s12">
      <i class="material-icons prefix">folder</i>
      <input class="form-control" (change)="fileChangeListener($event.target.files)" id="fileImportInput" #fileImportInput type="file" accept="text/csv"/>

   </div>
   <div class="table-responsive mt-2" *ngIf="fileUpload" id="pdfTable" #pdfTable>
      <table class="table align-items-center table-flush">
        <thead class="thead-light">
          <tr>
            <th  *ngFor="let frec of arrFirstLine" scope="col">{{frec}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let rec of csvRecords; let i = index;">
            <td *ngFor="let r of rec; let j = index;">{{rec[j]}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="row" *ngIf="fileUpload">
      <div class="col s4 center mt-5">
         <a (click)="Upload($event)" class="waves-effect waves-light btn tatt-btn mt-2 ml-2 mr-2">Upload</a>
         <a (click)="Cancel($event)" class="waves-effect waves-light btn #ef5350 white lighten-3 tatt-btn mt-2 ml-2" style="color:black">Cancel</a>
      </div>
      <div class="col s5"></div>
   </div>
   
</div>

<div class="row" *ngIf="!showFileUpload"> 
   <div class="table-responsive mt-2" id="pdfTable" #pdfTable>
      <h1>Do you want to rebuild the cache?</h1>
   </div>  
    <div class="row">
      <div class="col s4 center mt-5">
         <a (click)="CacheRebuild($event)" class="waves-effect waves-light btn tatt-btn mt-2 ml-2 mr-2">OK</a>
         <a (click)="CacheCancel($event)" class="waves-effect waves-light btn #ef5350 white lighten-3 tatt-btn mt-2 ml-2" style="color:black">Cancel</a>
      </div>
      <div class="col s5"></div>
   </div>
   
</div>